import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUndoAlt } from "@fortawesome/free-solid-svg-icons";
import { brandVerifiedAttributeStatus, brandVerifiedAttributeClasses } from "components/attributes/lib/constants";
import { faStickyNote } from "@fortawesome/free-regular-svg-icons";
import { removeAttrEntry, setPendingAttrEntry, setRejectedAttrEntry } from "./lib/attr-list";

export const BVQaColumn = ({
    isSupplierAttribute,
    attrName,
    attrGroup,
    attrNote,
    uuid,
    status,
    onUpdateStatus,
    onUpdateAttribute,
    refreshAttributeGroups,
    onAttrList,
    isCompleted,
}) => {
    const [showNote, setShowNote] = useState(false);
    const [note, setNote] = useState(attrNote ? attrNote : `${attrName} attribute was rejected and requires review.`);
    const btnLabel = isSupplierAttribute ? "Supplier" : "Internal";

    const onAccept = async () => {
        const update = await onUpdateAttribute(uuid, brandVerifiedAttributeStatus.Accepted);

        if (!update) {
            return;
        }

        onUpdateStatus(brandVerifiedAttributeClasses.ACCEPTED);
        onAttrList(removeAttrEntry(uuid));
    };

    const onReject = async () => {
        if (note === "") {
            setNote(`${attrName} attribute was rejected and requires review.`);
        }

        const update = await onUpdateAttribute(uuid, brandVerifiedAttributeStatus.Rejected, note);

        if (!update) {
            return;
        }

        onUpdateStatus(brandVerifiedAttributeClasses.REJECTED);
        onAttrList(
            setRejectedAttrEntry({
                uuid,
                sortGroupName: attrGroup,
                isSupplierAttribute,
            })
        );
    };

    const onReset = async () => {
        const update = await onUpdateAttribute(uuid, brandVerifiedAttributeStatus.Pending, "");

        if (!update) {
            return;
        }

        await refreshAttributeGroups();
        setNote("");
        onUpdateStatus(brandVerifiedAttributeClasses.PENDING);
        onAttrList(setPendingAttrEntry(uuid));
    };

    const onShowNotes = () => {
        setShowNote(true);
    };

    const onUpdateNote = (e) => {
        setNote(e.target.value);
    };

    const onSaveNote = async () => {
        await onUpdateAttribute(uuid, brandVerifiedAttributeStatus.Rejected, note);
        await refreshAttributeGroups();
        setShowNote(false);
    };

    const UndoButton = () => {
        return (
            <button
                className="button -primary -undo"
                onClick={onReset}
                disabled={isCompleted}
            >
                <FontAwesomeIcon icon={faUndoAlt} />
                <span className="m-l-8">Undo</span>
            </button>
        );
    };

    switch (status) {
        case brandVerifiedAttributeClasses.AUTO_ACCEPTED:
            return (
                <div className="flex align-center">
                    <em>Values are equal and auto-accepted</em>
                </div>
            );
        case brandVerifiedAttributeClasses.ACCEPTED:
            return (
                <div className="justify-content-between align-center bv-qa-buttons">
                    <em>Marked as Accept {btnLabel} Data</em>
                    <UndoButton />
                </div>
            );
        case brandVerifiedAttributeClasses.REJECTED:
            if (showNote) {
                return (
                    <div className="bv-qa-buttons flex flex-wrap justify-content-end">
                        <textarea
                            className="attribute-note"
                            value={note}
                            onChange={onUpdateNote}
                        ></textarea>
                        <button
                            className="button -primary"
                            onClick={onSaveNote}
                            disabled={isCompleted}
                        >
                            Save
                        </button>
                    </div>
                );
            }

            return (
                <div className="flex-wrap justify-content-between align-center">
                    <em>Marked as Reject {btnLabel} Data</em>
                    <div className="bv-qa-buttons">
                        <button
                            className="button"
                            onClick={onShowNotes}
                            disabled={isCompleted}
                        >
                            <FontAwesomeIcon icon={faStickyNote} />
                            <span className="m-l-8">Note</span>
                        </button>
                        <UndoButton />
                    </div>
                </div>
            );
        default:
            return (
                <div className="button-group bv-qa-buttons flex flex-wrap">
                    <>
                        <button
                            aria-label="accept"
                            className="button -primary"
                            onClick={onAccept}
                            disabled={isCompleted}
                        >
                            Accept {btnLabel} Data
                        </button>
                        <button
                            aria-label="reject"
                            className="button -error"
                            onClick={onReject}
                            disabled={isCompleted}
                        >
                            Reject {btnLabel} Data
                        </button>
                    </>
                </div>
            );
    }
};
